import { render, staticRenderFns } from "./AccountClosureRecordsList.vue?vue&type=template&id=5fa57563&scoped=true"
import script from "./AccountClosureRecordsList.vue?vue&type=script&lang=js"
export * from "./AccountClosureRecordsList.vue?vue&type=script&lang=js"
import style0 from "./AccountClosureRecordsList.vue?vue&type=style&index=0&id=5fa57563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa57563",
  null
  
)

export default component.exports